import styled from 'styled-components';



export const Container = styled.div`

display: flex;
justify-content: space-between;
align-items: center;

width:100%;
height:80px; 

padding: 0 4.4rem;

#select{
width: 35% !important;
}

`;

export const Block = styled.div`


  height:100%; 

  display:flex;
  display: flex;
  align-items: center;

  &:first-child{
    display: flex;
    justify-content: flex-start;

    p{
    text-align: left;
    }

    @media (max-width: 1540px){ 
    display: none;
    } 
  }

  &:nth-child(3){
    display: flex;
    justify-content: flex-end;
  }


  button{
    border: 0;

    height:30px; 
    width: 30px; 

    border: 2px solid #000000;
    box-sizing: border-box;
    border-radius: 5px;
    margin: 0.3rem;

    //small devices hover is locked when you click, so disable this effect
    @media (min-width: 800px){ 
      &:hover{
        background-color:#ececec;
        }
    } 
    display: flex;
    align-items: center;
    background-color:white;



    //small devices hover is locked when you click, so disable this effect
    @media (min-width: 800px){ 
      &:hover{
        background-color:#ececec;
        }
    } 

    &:disabled{
      background-color:#ececec;
      cursor:not-allowed;
    }



   


    img{
      height:100%; 
      width: 100%; 
       }



  }





  div{
      display: flex;
      align-items: center;
      justify-content: center;

      border: 2px solid #000000;
      box-sizing: border-box;
      border-radius: 5px;
      margin: 0.6rem;

      height:30px; 
      background-color:white;

  }

  p{
      text-align: center;
      padding: 0.5rem;

      min-width: 70px; 

      color: black;
      font-size:1rem;
      margin-bottom:0;
 }

`;

export const Form = styled.form`



  display: flex;
  justify-content: center;
  align-items: center;
  width:100%;


  @media (max-width: 1540px){ 
    display: none;
    }

  label{
    color: black;
    font-size:1rem;
    margin-right: 0.5rem;
  }

`;
